import { render } from "./About.vue?vue&type=template&id=ddd9c682&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=ddd9c682&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ddd9c682"

export default script